import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PeakMark } from "@/components/PeakMark";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-28 bg-white"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="border-t border-b border-neutral-200 py-16 md:py-20"
        >
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-4 mb-6">
                <PeakMark size={22} className="text-neutral-900" />
                <span
                  data-testid="contact-overline"
                  className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#9B1C1C]"
                >
                  Work With Me
                </span>
              </div>
              <h2
                data-testid="contact-heading"
                className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-neutral-950 leading-[1.02]"
              >
                Start the<br />
                <span className="italic font-light">conversation</span>
                <span className="text-[#9B1C1C]">.</span>
              </h2>
              <p className="mt-6 text-[17px] text-neutral-600 leading-relaxed font-medium max-w-xl">
                Every note is read by me, personally. Most engagements begin
                with a short introductory call to see if SSG is the right
                fit.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to="/contact"
                data-testid="contact-cta"
                className="group inline-flex items-center gap-3 bg-[#0A0A0A] hover:bg-[#9B1C1C] text-white px-8 py-4 text-[11px] tracking-[0.24em] uppercase font-bold transition-colors"
              >
                Start the Conversation
                <ArrowUpRight
                  size={16}
                  strokeWidth={1.6}
                  className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
